<section class="softball-spectator">
  <h2>Live softball</h2>

  @if (games().length) {
    <ul>
      @for (game of games(); track game.id) {
        <li>
          <span class="opp">vs {{ game.opponentName }}</span>
          <span class="score">{{ game.homeRuns }} – {{ game.awayRuns }}</span>
        </li>
      }
    </ul>
  } @else {
    <p>No games available.</p>
  }
</section>
